<template>
  <div class="animated fadeIn" style="min-height: 880px; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin;">
    <div class="row">
      <div class="col-12">
        <h3 class="text-third"><i class="fas fa-box-open"></i> NxGED</h3>
        <small>Gerenciamento Eletrônico de Documentos.</small>
      </div>
      <div class="col-12 mt-3">
        <div class="input-group">
          <b-form-input type="text"
            :placeholder="'Digite para pesquisar'"
            v-model="form.search.value"
            :size="form.search.maxlength"
            :required="form.search.required"
            :state="form.search.state"></b-form-input>
            <span class="input-group-addon"><i class="fas fa-search"></i></span>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-card style="min-height: 540px; overflow-y: auto;">
          <template #header>
            <div class="col-12 text-left" style="padding: 1px;">
            <i class="fas fa-archive text-third"></i>
            <b>Seções</b>
            <i class="fas fa-sync text-third pointer" style="position: absolute; right: -5px;" @click="onReload"></i>
          </div>
          </template>
          <b-card-body style="padding: 0">
            <TreeviewMenuGed ref="TreeviewMenuGed" v-on:New="onNewItemMenu" v-on:OpenGed="onOpenGed" />
          </b-card-body>
          <template #footer>
            <div class="text-third pt-2 w-100 pointer" @click.prevent="onCreateSection"><i class="fas fa-plus"></i> Criar Seção</div>
          </template>
        </b-card>
      </div>

      <div class="col-12">
        <b-card>
          <div class="text-third v-100" style="padding: 1px;">
            <div class="text-bold"><i class="fas fa-info-circle"></i> Armazenamento</div>
            <small>Detalhes sobreo uso do espaço</small>
          </div>
          <div class="pt-2">
            <span style="font-size: 11px;">0%</span>
            <span style="position: absolute; right: 10px; font-size: 11px;">100%</span>
            <b-progress :value="1" :max="100" variant="success" show-progress animated></b-progress>
          </div>
          <div class="pt-3 text-right">
            <small class="">
              Utilizando 0Gb de 100Gb <i class="fas fa-database text-third"></i>
            </small>
          </div>
        </b-card>
      </div>
    </div>
    <ModalSection ref="modalSection" v-on:Saved="onSavedSection"></ModalSection>
    <ModalNewItemMenu ref="modalNewItemMenu" v-on:Saved="onSavedItemMenu"></ModalNewItemMenu>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import TreeviewMenuGed from './components/Treeview/treeviewMenuGed.vue'
import ModalSection from './components/modalsection.vue'
import ModalNewItemMenu from './components/modalnewmenu.vue'
import GedSecaoRepository from '@/shared/http/repositories/ged/gedsecao.js'
import GedMenuRepository from '@/shared/http/repositories/ged/gedmenu.js'

const searchForm = {
  search: {
    value: '',
    maxlength: 100,
    required: false,
    state: null
  }
}
const searchModel = {
  search: null
}

export default {
  name: 'LeftbarGED',
  mixins: [ActionsForm],
  data () {
    return {
      data: searchModel,
      form: searchForm,
      menus: []
    }
  },
  components: {
    TreeviewMenuGed,
    ModalSection,
    ModalNewItemMenu
  },
  computed: {
    menuItem () {
      return this.menuItens
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onReload () {
      this.onLoad()
    },
    onOpenGed (obj) {
      this.$emit('OpenGed', obj)
    },
    async onLoadAll () {
      let mySections = await this.onLoadAllSections()
      let sections = await this.onGetMenuBySection(mySections)
      this.$refs.TreeviewMenuGed.onLoad(sections)
    },
    async onGetMenuBySection (sections) {
      let mySections = []
      for (let index = 0; index < sections.length; index++) {
        const element = sections[index]
        let menu = await this.onLoadAllMenu(element)
        let section = {
          id: element.id,
          nome: element.nome,
          items: menu
        }
        mySections.push(section)
      }
      return mySections
    },
    async onLoadAllSections () {
      let result = []
      await GedSecaoRepository.GetAll()
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            result = data
          }
        })
        .catch(this.onException)
      return result
    },
    async onLoadAllMenu (section) {
      let result = []
      await GedMenuRepository.GetAllBySecao(section.id)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            result = data
          }
        })
        .catch(this.onException)

      return result
    },
    onCreateSection () {
      this.$refs.modalSection.showModal()
    },
    onNewItemMenu (secao, menu, nivel) {
      let obj = {
        secao: secao,
        menu: menu,
        nivel: nivel
      }
      this.$refs.modalNewItemMenu.showModal(obj)
    },
    onSavedSection () {
      this.onLoad()
    },
    onSavedItemMenu () {
      this.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/leftcontent/leftbar.vue